import AddressField from "../DynamicFieldComponents";
import CheckboxField from "../DynamicFieldComponents/CheckboxField";
import EmailField from "../DynamicFieldComponents/EmailField";
import NumberField from "../DynamicFieldComponents/NumberField";
import PercentField from "../DynamicFieldComponents/PercentField";
import PhoneField from "../DynamicFieldComponents/PhoneField";
import SingleLineTextField from "../DynamicFieldComponents/SingleLineTextField";
import UrlField from "../DynamicFieldComponents/UrlField";
import DateField from "../DynamicFieldComponents/DateField";
import MultiLineTextField from "../DynamicFieldComponents/MultiLineTextField";
import PersonNameField from "../DynamicFieldComponents/PersonNameField";
import CountryField from "../DynamicFieldComponents/CountryField";
import UsstatesField from "../DynamicFieldComponents/UsstatesField";
import RateField from "../DynamicFieldComponents/RateField";
import PeriodField from "../DynamicFieldComponents/PeriodField";
import AmountField from "../DynamicFieldComponents/AmountField";
import SingleSelectField from "../DynamicFieldComponents/SingleSelectField";
import RadioField from "../DynamicFieldComponents/RadioField";

const CustomFieldComponentsMap = {
  ADDRESS: AddressField,
  CHECKBOX: CheckboxField,
  EMAIL: EmailField,
  NUMBER: NumberField,
  PERCENT: PercentField,
  PHONE: PhoneField,
  SINGLE_LINE_TEXT: SingleLineTextField,
  URL: UrlField,
  DATE: DateField,
  MULTI_LINE_TEXT: MultiLineTextField,
  PERSON_NAME: PersonNameField,
  COUNTRY: CountryField,
  US_STATES: UsstatesField,
  RATE: RateField,
  PERIOD: PeriodField,
  AMOUNT: AmountField,
  SINGLE_SELECT: SingleSelectField,
  RADIO: RadioField,
};

export { CustomFieldComponentsMap as default };



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/CustomDynamicFieldSelect/CustomFieldComponentsMap.js